module.exports = __webpack_public_path__ + "prev1.png?b77d02d3e4ac359100feccf7e0165c16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prev1.png
// module id = 64
// module chunks = 0